<template>
  <div>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-map-marker</v-icon>
          PAISES
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          class="mt-5"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-checkbox
          v-model="incluirInactivos"
          label="Incluir inactivos"
          @change="cargarLista"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="abrirDialogPais(null)">
          <v-icon>mdi-plus-circle-outline</v-icon> Nuevo pais
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="lista"
        :items-per-page="itemsPerPage"
        :search="search"
        :loading="loadingTable"
        class="elevation-1"
      >
        <template v-slot:item.opcion="{ item }">
          <v-btn icon color="green" @click="abrirDialogPais(item.PAIS_ID)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn icon color="red" @click="eliminarPais(item.PAIS_ID)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogPais" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-icon class="mb-1">mdi-map-marker</v-icon>
          <span class="headline">Pais | {{ datosPais.PAIS_ID }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="formPais">
              <v-row>
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field
                    :rules="requiredRule"
                    v-model="datosPais.NOMBRE"
                    label="Nombre "
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field
                    v-model="datosPais.PAIS_CODIGO"
                    label="Código ISO 2"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field v-model="datosPais.ISO3" label="Código ISO 3">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-center">
            <v-btn small color="primary" @click="guardarPais">
              <v-icon>mdi-content-save</v-icon> Guardar
            </v-btn>
            &nbsp;&nbsp;
            <v-btn small @click="dialogPais = !dialogPais">
              <v-icon>mdi-cancel</v-icon> Cancelar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";

export default {
  name: "PaisComponent",
  data: () => ({
    headers: [
      { text: "Opciones", value: "opcion" },
      { text: "Codigo", value: "PAIS_CODIGO" },
      { text: "Nombre", value: "NOMBRE" },
      { text: "ISO3", value: "ISO3" },
    ],

    requiredRule: [(v) => !!v || "El campo es requerido"],
    emailRules: [
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Ingrese un Email válido",
    ],
    lista: [],
    options: {},
    dialog: false,
    notifications: false,
    sound: true,
    widgets: true,

    search: null,
    incluirInactivos: false,

    dialogPais: false,
    datosPais: {
      PAIS_ID: "",
      NOMBRE: "",
      PAIS_CODIGO: "",
      ISO3: "",
    },

    itemsPerPage: 20,
    creaPais: true,
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user"]),
    ...mapGetters("access", [""]),
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setLoadingTable",
      "setTitleToolbar",
    ]),

    ...mapActions("master", ["requestApi", "alertNotification"]),

    cargarLista() {
      this.setLoadingTable(true);
      this.setUrl("api/lista-paises");
      this.requestApi({
        method: "GET",
        data: {
          incluirInactivos: this.incluirInactivos,
        },
      })
        .then((res) => {
          //console.log(res);
          this.lista = res.data;
          this.pageCount = 10;
        })
        .catch(() => {})
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    modificarPais() {
      this.setUrl("api/modificar-pais");
      this.requestApi({
        method: "POST",
        data: {
          pais: this.datosPais,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarLista();
          this.dialogPais = false;
        })
        .then(() => {});
    },

    abrirDialogPais(paisid) {
      this.creaPais = false;
      if (paisid == null) {
        this.datosPais = {
          PAIS_ID: "",
          NOMBRE: "",
          PAIS_CODIGO: "",
          ISO3: "",
        };
        this.creaPais = true;
      }
      this.setUrl("api/pais");
      this.requestApi({
        method: "GET",
        data: {
          PAIS_ID: paisid,
        },
      })
        .then((res) => {
          if (res.data.pais != null) {
            this.datosPais = res.data.pais;
          }

          this.dialogPais = true;
        })
        .then(() => {});
    },

    eliminarPais(paisId) {
      Vue.swal({
        html: "Está seguro de eliminar el país ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cerrar",
        ...this.paramAlertQuestion,
      }).then((result) => {
        if (result.isConfirmed) {
          this.setUrl("api/borrar-pais");
          this.requestApi({
            method: "POST",
            data: {
              PAIS_ID: paisId,
            },
          }).then((res) => {
            //console.log(res);
            this.cargarLista();
            this.alertNotification({ param: { html: res.data.msg } });
          });
        }
      });
    },
    guardarPais() {
      if (!this.$refs.formPais.validate()) {
        return false;
      }
      if (this.creaPais == true) {
        this.crearPais();
      } else {
        this.modificarPais();
      }
    },
    crearPais() {
      console.log(this.datosPais);
      this.setUrl("api/crear-pais");
      this.requestApi({
        method: "POST",
        data: {
          pais: this.datosPais,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.dialogPais = false;
          this.cargarLista();
        })
        .then(() => {});
    },
  },

  mounted() {
    document.title = "Sistema de carga";
    this.setTitleToolbar("Paises");
    this.cargarLista();
  },
};
</script>
